import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import { localize, configure } from 'vee-validate';

Vue.use(VueI18n);

export const default_locale = process.env.VUE_APP_I18N_LOCALE || 'ko-KR';

const i18n = new VueI18n({
  locale: default_locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-US',
  //messages: loadI18nBundle(),
});

const adminLocales = require.context(
  '@admin/locales',
  true,
  /[A-Za-z0-9-_,\s]+\.json$/i,
);
const customerLocales = require.context(
  '@customer/locales',
  true,
  /[A-Za-z0-9-_,\s]+\.json$/i,
);
const ownerLocales = require.context(
  '@owner/locales',
  true,
  /[A-Za-z0-9-_,\s]+\.json$/i,
);

function loadI18nBundle(path, locale) {
  const locales =
    path === 'admin'
      ? adminLocales
      : path === 'customer'
      ? customerLocales
      : ownerLocales;
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/*function loadMomentLocale(locale: string) {
  if (locale !== 'en' && locale !== 'en-US') {
    return import(`../../node_modules/moment/locale/${aliasLocale(locale)}.js`);
  }
  function aliasLocale(locale: string) {
    if (locale.startsWith('ko')) {
      return 'ko';
    } else {
      return locale.toLowerCase();
    }
  }
}*/

function loadVeeValidateLocale(locale) {
  return import(`vee-validate/dist/locale/${aliasLocale(locale)}.json`);

  function aliasLocale(locale) {
    if (locale.startsWith('ko')) {
      return 'ko';
    } else {
      return locale.toLowerCase();
    }
  }
}

export function load(path, locale) {
  return Promise.all([
    loadI18nBundle(path, locale),
    loadVeeValidateLocale(locale),
  ]).then(([i18nBundle, veeValidateBundle]) => {
    i18nBundle[locale].validation = Object.assign(
      {},
      veeValidateBundle.messages,
      i18nBundle[locale].validation,
    );
    localize(locale, veeValidateBundle);
    i18n.locale = locale;
    i18n.setLocaleMessage(locale, i18nBundle[locale]);
    //console.log(i18nBundle[locale]);
    return i18n;
  });
}

export { i18n };
